import { RequestForm } from './request-form.component';

export * from './request-form.component';
export default RequestForm;

RequestForm.define('der-tailormade-appointment-booking-request-form');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking-request-form': RequestForm;
    }
}
